export const toFacilityId = (value) => {
	if (value == null || value === '') return null
	if (typeof value === 'object') return value._id ? String(value._id) : String(value)
	return String(value)
}

export const matchesFacility = (record, facilityId) => {
	const expected = toFacilityId(facilityId)
	const actual = toFacilityId(record?.facility_id)

	return Boolean(expected && actual && expected === actual)
}
